import { apiClient } from 'modules/utils/httpClient'
import { endpoints } from 'modules/endpoints'
import { License, LicenseListRequestSorting, LicenseListRequestFilter, LicenseDTO } from './types'
import { ListResponse } from 'types/api'

export const getList = (
  filter: LicenseListRequestFilter,
  sorting: LicenseListRequestSorting,
  page: number,
  pageSize: number,
) => {
  return apiClient.get<ListResponse<License>>(endpoints.license(), {
    ...filter,
    ...sorting,
    page: page,
    page_size: pageSize,
  })
}

export const getItem = (id: string) => {
  return apiClient.get<License>(endpoints.license(id))
}

export const addItem = (dto: LicenseDTO) => {
  return apiClient.post<License>(endpoints.license(), dto)
}

export const updateItem = (id: string, dto: Partial<LicenseDTO>) => {
  return apiClient.put<License>(endpoints.license(id), dto)
}

export const removeItem = (id: string) => {
  return apiClient.delete<License>(endpoints.license(id))
}
